import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { launchParkingBillingSetting } from '../api/parking-billing-setting.ts';

export default function useLaunchParkingBillingSetting(): UseMutationResult<
  string,
  Error,
  { id: string; offset: number; accountantIds: string[] }
> {
  return useMutation({
    mutationFn: ({ id, offset, accountantIds }) =>
      launchParkingBillingSetting(id, offset, accountantIds),
  });
}
